import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPost from "../axios/axios-post";
import axiosPut from "../axios/axios-put";
import axiosGet from "../axios/axios-get";

export const ProductAPI = Object.freeze({
  getAll: createAsyncThunk("get/get-products", async (params) => {
    return await axiosGet.get(`/product`, { params });
  }),

  getOne: createAsyncThunk("get/one-product", async (slug) => {
    return await axiosGet.get(`/product/${slug}`);
  }),

  getCategories: createAsyncThunk("get/get-categories", async () => {
    return await axiosGet.get(`/categories`);
  }),

  update: createAsyncThunk("put/put-product", async (data) => {
    return await axiosPut.put(`/product/${data.slug}`, data);
  }),

  refresh: createAsyncThunk("post/refresh-products", async () => {
    try {
      const response = await axiosPost.post("/fetch-products");
      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data || error.message);
    }
  }),
});
